
export const updateMetaTag = (addedTags: Set<HTMLElement> | null, name?: string, content?: string, property?: string) => {
    // Select all meta tags with the same name
    const metas = document.querySelectorAll(`meta[name="${name}"]`).length
        ? document.querySelectorAll(`meta[name="${name}"]`)
        : document.querySelectorAll(`meta[property="${property}"]`);

    // Remove any duplicate <meta> tags
    if (metas.length > 1) {
        metas.forEach((meta, index) => {
            if (index !== 0) {
                meta.remove(); // Remove duplicate
            }
        });
    }

    const meta = metas[0] || document.createElement('meta');
    if (!metas.length) {
        name && meta.setAttribute('name', name);
        content && meta.setAttribute('content', content);
        property && meta.setAttribute('property', property);
        document.head.appendChild(meta);
    }

    if (meta.getAttribute('content') !== content) {
        meta.setAttribute('content', content || '');
    }

    addedTags?.add(meta as HTMLElement);
};

export const removeMetaTag = (name?: string, property?: string) => {
    document.querySelector(`meta[name="${name}"]`)?.remove();
    document.querySelector(`meta[property="${property}"]`)?.remove();
};
